// @ts-check
/** Admin CRUD for the fashion models KAAY shoots with. There is no delete; deactivate instead. */

import api from '../utils/apiClient';

const adminFashionModelService = {
  async list() {
    return api.get('/api/admin/fashion-models');
  },

  /** @param {Record<string, unknown>} data */
  async create(data) {
    return api.post('/api/admin/fashion-models', data);
  },

  /**
   * @param {string} id
   * @param {Record<string, unknown>} data
   */
  async update(id, data) {
    return api.patch(`/api/admin/fashion-models/${id}`, data);
  },
};

export default adminFashionModelService;
